<template>
    <card shadow>
      <div class="pt-2 text-left">
        <h3 class="h3 title">
          <span v-if="pendingOrg.type === 'partner' || pendingOrg.type === 'agency'" class="d-block">Waiting on a response from {{pendingOrg.name}}</span>
          <span v-if="pendingOrg.type === 'employer'" class="d-block">For legal reasons we need to approve you as an employer. You will receive email confirmation within 24 hours. For immediate approval call: 813.438.4351</span>
        </h3>
      </div>
    </card>
</template>

<script>
export default {
  name: "waitingresponsecard",
  props: {
    pendingOrg: {},
  }
};
</script>

<style scoped>
</style>
